import { useLocalizeText } from '@mews/framework';
import { ResultListProps } from '../results/ListTitle';
import { highlight } from '../../utils/highlight';
import { showRouteInModal } from '../../../app/actions/common';
import { AssistantNavigation } from '../results/navigation/AssistantNavigation';
import { SearchType } from '../../assistantSearchTypes';
import { AssistantSearchListItemProps } from './useAssistantSearchResultListMap';

interface NavigationListProps extends ResultListProps {
    navigations: AssistantNavigation[];
}

interface PrimaryTextProps {
    navigation: AssistantNavigation;
    searchTerm: string;
}

const PrimaryText = ({ navigation, searchTerm }: PrimaryTextProps) => {
    const localizeText = useLocalizeText();
    const title = highlight(localizeText({ textKey: navigation.titleKey }) ?? '', searchTerm);
    return <>{title}</>;
};
const SecondaryText = ({ navigation, searchTerm }: PrimaryTextProps) => {
    if (!navigation.description) return <></>;
    const description = highlight(navigation.description, searchTerm);
    return <>{description}</>;
};

export const useNavigationList = ({ navigations, searchTerm }: NavigationListProps): AssistantSearchListItemProps[] =>
    navigations.map((navigation) => ({
        itemId: navigation.id ?? navigation.routeName,
        primaryText: <PrimaryText navigation={navigation} searchTerm={searchTerm} />,
        secondaryText: <SecondaryText navigation={navigation} searchTerm={searchTerm} />,
        leftIcon: <></>,
        routeAction: showRouteInModal(navigation.routeName, navigation.params),
        searchType: SearchType.Navigation,
    }));
